import React from 'react';
import { shape, string } from 'prop-types';

import StatusTag from '../StatusTag';

import s from './index.module.css';
import { ReactComponent as AlertIcon } from './assets/alertIcon.svg';

const OrderStatus = ({
  statusInfo,
}) => {
  return (
    <>
      {statusInfo.statusText &&
        <div className={s.orderStatus}>
          <div className={s.alertIcon}>
            <AlertIcon />
          </div>
          <div className={s.orderStatusDescription}>{statusInfo.statusText}</div>
        </div>
      }
      <StatusTag children={statusInfo.status} background={statusInfo.badgeColor} />
    </>
  );
};

OrderStatus.propTypes = {
  statusInfo: shape({
    status: string,
    badgeColor: string,
    statusText: string,
  })
};

export default OrderStatus;
